import {
  GenericServiceValue,
  PersonalDoctorValue,
  PharmacologicalTreatmentValue,
  PrescriptionFormValue,
} from '../models/prescription.interface';

export interface PrescriptionsDraftsState {
  drafts: PrescriptionFormValue<PharmacologicalTreatmentValue | GenericServiceValue | PersonalDoctorValue>[];
}

export const initialPrescriptionsDraftsState: PrescriptionsDraftsState = {
  drafts: [],
};
